var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Zoom = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", width: "100%", height: "100%" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("circle", { cx: "25", cy: "25", r: "25", fill: "#000", opacity: ".2" }),
            React.createElement("path", { fill: color, fillRule: "nonzero", d: "M21.136 13.278a9 9 0 0 1 7.241 14.346l7.812 7.812a1.34 1.34 0 0 1-1.895 1.895l-7.812-7.812a9 9 0 1 1-5.346-16.241zm0 2a7 7 0 1 0 4.921 11.978.173.173 0 0 1 .026-.03l.031-.027a7 7 0 0 0-4.978-11.921z" }))));
};
Zoom.defaultProps = {
    color: '#FFF',
};
export default Zoom;
//# sourceMappingURL=Zoom.js.map